export enum EngubatorCommonSettingsKeyEnum {
	VeerouteUrl = "veeroute_url",
}
